<div [id]="id() + '-card'" class="card">
    @if (customHeader()) {
        <ng-content select="[customHeader]"></ng-content>
    } @else if (header()) {
        <div class="card-header">
            <div>
                @if (icon()) {
                    <span aria-hidden="true">
                        <i [class]="icon()" [style.color]="iconColor()"></i>
                    </span>
                }
                <span class="title"> {{ header() | translate }}</span>
            </div>

            @if (hasRefreshButton()) {
                <btn-icon
                    [id]="'refresh-info-' + id()"
                    [ariaLabel]="refreshButtonLabel()"
                    [tooltip]="refreshButtonLabel()"
                    [icon]="'fa-solid fa-sync'"
                    [severity]="'primary'"
                    [outlined]="true"
                    [rounded]="true"
                    [text]="true"
                    (onClick)="refreshButton.emit()"></btn-icon>
            }
        </div>
    }

    <ng-content></ng-content>
</div>
